import React, { Component } from 'react';
import _ from "lodash";
import { uuid } from "core/utils";

class GridMultilineBooleanCellTemplate extends Component {
    constructor(props) {
        super();

        this.props = props;
    }

    render() {
        const missingProductIcon = (
            <i style={{
                display: "inline-block",
                ariaLabel: "Label"
            }} 
            className="u-icon u-icon--sml u-icon--products--warning" title="Missing Product"></i>
        );

        const noteIcon = () => (
            <i style={{
                display: "inline-block",
                ariaLabel: "Label"
            }} 
            className="u-icon u-icon--sml u-icon--flag--red" title= '' onClick = { () => this.props.edit(this.props.dataItem)}></i>
        );

        return (
            <td>
                <div className="type--left">
                    {_.map(this.props.dataItem[this.props.field], (i, key) => {
                        const isMissingProduct = this.props.dataItem.missingProduct[key] === true;
                        const isNoteActive =  this.props.dataItem.facilityOrderTemplateNotes[key].length != 0;
                        return (
                            i ? (
                            <div key={uuid()} className="type--center">
                                <i className="u-icon u-icon--sml u-icon--active u-mar--right--tny"></i>
                                { isMissingProduct && missingProductIcon }
                                { isNoteActive && noteIcon() }
                            </div>
                        ) : this.props.displayFaultyValue ? (
                            <div className="type--center" key={uuid()}>
                                <i className="u-icon u-icon--sml u-icon--inactive u-mar--right--tny"></i>
                                { isMissingProduct && missingProductIcon }
                                { isNoteActive && noteIcon() }
                            </div>
                        ) : 
                        <div className="type--center" key={uuid()}>
                            { isMissingProduct && missingProductIcon }
                            { isNoteActive && noteIcon() }
                            { !isMissingProduct && !isNoteActive && <div className="u-mar--right--tny" style={{width:"15px", height:"15px", display: "inline-block"}}></div>}
                        </div>
                        // <React.Fragment key={uuid()}>
                        //     { isMissingProduct && missingProductIcon }
                        //     { isNoteActive && noteIcon() }
                        //     { !isMissingProduct && !isNoteActive && <div className="u-mar--right--tny" style={{width:"15px", height:"15px", display: "inline-block"}}></div>}
                        // </React.Fragment>
                        );
                    })}
                </div>
            </td>
        );
    }
}

export default GridMultilineBooleanCellTemplate;
